import { registerAction } from '../../Action'

const REMOVE_ANNOTATION = 'REMOVE_ANNOTATION'

const reducer = (state = {}, action) => {
  const annotations = { ...state.jsonApiEntities.annotation }
  delete annotations[action.payload]
  return {
    ...state,
    jsonApiEntities: { ...state.jsonApiEntities, annotation: annotations },
  }
}

const removeAnnotation = registerAction(REMOVE_ANNOTATION, { reducer })

export default removeAnnotation
